<template>
	<div>
		<el-drawer
			:title="title"
			:visible.sync="visible"
			:append-to-body="appendToBody"
			:size="width"
			:before-close="handleClose"
			:wrapperClosable="wrapperClosable"
			custom-class="drawer-template"
		>
			<div>
				<tip size="small" content="完成消息推送配置后，新增商品时，系统将自动同步新商品，无需手动操作同步"></tip>
				<div class="mt-24">
					<h3 class="yx-color-text-primary font-h3-medium">配置步骤</h3>
					<p class="yx-color-text-primary font-h4-regular mt-16">1.选择需要自动同步商品的团长账号，点击下方【生成参数】，获取专属的配置参数</p>
					<div class="mt-16 flex-row-align-center">
						<label class="yx-color-text-primary font-h4-regular mr-12">团长</label>
						<el-select v-model="form['thirdShopId']" placeholder="请输入/选择" filterable>
							<el-option v-for="item in list" :key="item.thirdShopId" :label="item.authShopName" :value="item.thirdShopId">
								<div class="flex-row-align-center">
									<platform-icon style="flex-shrink: 0" class="mr-4" :platformId="platformId"></platform-icon>
									<div class="fz-14 institution-name">{{ item.authShopName | textFormat(9) }}</div>
								</div>
							</el-option>
						</el-select>
						<el-button type="primary" class="ml-16" :loading="loading" :disabled="!form.thirdShopId" @click="confirm">生成参数</el-button>
					</div>
					<p class="yx-color-text-primary font-h4-regular mt-24">2.前往视频号机构管理后台，在【设置-开发信息-消息推送】处，填入对应参数</p>
					<el-image class="mt-16" :src="imgSrc" :preview-src-list="[imgSrc]"></el-image>
					<img />
				</div>
			</div>
		</el-drawer>
		<setting-params-model ref="settingParamsModel" />
	</div>
</template>
<script>
import { debounce } from 'lodash';
import Tip from '@/components/ui/tip';
import SettingParamsModel from './settingParamsModel';
import { getSpInstitutionList } from '@/api/teamManage';
export default {
	data() {
		return {
			title: '自动同步商品', // 弹窗标题
			visible: false, // 弹窗显隐
			loading: false, // 按钮loading状态
			form: {
				thirdShopId: '', // 团长id
			},
			list: [],
			platformId: dataMap.PLATFORM_SP.value, // 平台id
			imgSrc: require('@/assets/public/autoasyncgoodssetting.png'), // 图片路径
		};
	},
	computed: {
		// 弹窗尺寸转换为实际px值
		width() {
			return dataMap.DRAWER_SIZE_WIDTH[this.size];
		},
	},
	created() {
		this.initData();
		this.getList();
	},
	mounted() {},
	methods: {
		// 主动显示弹窗
		show() {
			this.visible = true;
		},
		// 清空数据并关闭弹窗
		handleClose() {
			this.visible = false;
			this.form.thirdShopId = '';
		},
		// 确认按钮点击事件
		confirm: debounce(function () {
			// 按钮loading开启
			this.loading = true;
			try {
				// 刷新列表（外部重新获取数据）
				this.$refs.settingParamsModel.show(this.form['thirdShopId']);
			} finally {
				// 按钮loading关闭
				this.loading = false;
			}
		}, 300),
		// 不需要响应式的数据进行初始化设置
		initData() {
			// 抽屉是否添加到body节点下
			this.appendToBody = true;
			// 抽屉尺寸，small:500px，default: 600px，normal:800px，large:1080px
			this.size = 'normal';
			// 点击蒙版是否关闭
			this.wrapperClosable = false;
		},
		async getList() {
			try {
				this.loading = true;
				const res = await getSpInstitutionList({
					'page-index': 1,
					'page-size': 100,
				});
				let { code, data } = res;
				if (code !== 0) return;
				this.list = data.list.map(item => ({
					authShopName: item.authShopName,
					thirdShopId: item.thirdShopId,
				}));
			} finally {
				this.loading = false;
			}
		},
	},
	components: { Tip, SettingParamsModel },
	beforeDestroy() {},
};
</script>
<style lang="less" scoped>
.el-select-dropdown__item {
	border-bottom: 1px solid @color-gy4;
}
</style>
